import { isLength } from "lodash";
import React, { Component } from "react";
import { HiX, HiXCircle } from "react-icons/hi";
import {
  RiCheckFill,
  RiFlag2Fill,
  RiFlag2Line,
  RiXboxFill,
} from "react-icons/ri";
import ReactTooltip from "react-tooltip";
import { Popover, PopoverBody } from "reactstrap";
import "./priority-container.css";
import { task_priority } from "../../utils/constants";

export default class PriorityContainer extends Component {
  constructor(props) {
    super(props);
    console.log(props.forceOpen);
    this.state = {
      openPopover: props.forceOpen || false,
      // flagColor:  task&&task.priority?task.priority:
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.forceOpen !== nextProps.forceOpen) {
      this.setState({ openPopover: nextProps.forceOpen });
    }
  }

  togglePopover = () => {
    this.setState({ openPopover: !this.state.openPopover });
  };
  getColorWithValue = value => {
    switch (value) {
      case 3:
        return "red";
      case 2:
        return "rgb(255, 193, 0)";
      case 1:
        return "#00e0ffe0";
      case "NONE":
        return "#d7d4d4";
    }
  };

  handleChange = priority => {
    this.props.handlePriorityChange({ ...this.props.task, priority: priority });
    this.togglePopover();
  };
  render() {
    const { task, isActive } = this.props;

    return (
      <div className="priority-container-main-div">
        {task && task.priority ? (
          <div className="priority-container-selected-div ml-2 cursor-pointer">
            <RiFlag2Fill
              onClick={() => {
                if (isActive != false && this.props.canEdit) {
                  this.togglePopover();
                }
              }}
              id={`priorityPopOver${this.props.task._id}`}
              size={this.props.size}
              color={this.getColorWithValue(task.priority)}
              data-tip={
                task_priority(task.priority)
                // task.priority == 3
                // ? "High"
                // : task.priority == 2
                // ? "Medium"
                // : "Low"
              }
            />
            <ReactTooltip />
            <span className="priority-popover-text ac-tbl-pri-txt">
              {" "}
              {task_priority(task.priority)} {this.props.concatVal}
            </span>
            {/* <div className="remove-priority-section">
              <HiXCircle size={"15px"} color="gray" />{" "}
            </div> */}
          </div>
        ) : (
          <div className="priority-container-no-selected-div ml-2 cursor-pointer">
            <RiFlag2Line
              onClick={() => {
                if (isActive != false && this.props.canEdit) {
                  this.togglePopover();
                }
              }}
              id={`priorityPopOver${this.props.task._id}`}
              size={this.props.size || "20px"}
              // color="gray"
              color={this.getColorWithValue("NONE")}
              data-tip={"No priority"}
            />
            <span className="priority-popover-text ac-tbl-pri-txt">
              {" "}
              No priority
            </span>
            <ReactTooltip />
          </div>
        )}

        <div className="priority-popover-place">
          <Popover
            className="p-3"
            isOpen={this.state.openPopover}
            target={`priorityPopOver${this.props.task._id}`}
            placement="bottom"
            hideArrow
            toggle={() => this.togglePopover()}
            container="inline"
          >
            <PopoverBody className={"priority-popover-body"}>
              <div
                className="priority-popover-row-item"
                onClick={() => this.handleChange(3)}
              >
                <RiFlag2Fill size="22px" color={this.getColorWithValue(3)} />{" "}
                <span className="priority-popover-text">
                  {" "}
                  {task_priority(3)}
                </span>
                {task.priority === 3 && (
                  <div className="priority-selected-div">
                    <RiCheckFill size={"22px"} />
                  </div>
                )}
              </div>
              <div
                className="priority-popover-row-item"
                onClick={() => this.handleChange(2)}
              >
                <RiFlag2Fill size="22px" color={this.getColorWithValue(2)} />{" "}
                <span className="priority-popover-text">
                  {" "}
                  {task_priority(2)}
                </span>
                {task.priority === 2 && (
                  <div className="priority-selected-div">
                    <RiCheckFill size={"22px"} />
                  </div>
                )}
              </div>
              <div
                className="priority-popover-row-item"
                onClick={() => this.handleChange(1)}
              >
                <RiFlag2Fill size="22px" color={this.getColorWithValue(1)} />{" "}
                <span className="priority-popover-text">
                  {" "}
                  {task_priority(1)}
                </span>
                {task.priority === 1 && (
                  <div className="priority-selected-div">
                    <RiCheckFill size={"22px"} />
                  </div>
                )}
              </div>
              <div
                className="priority-popover-row-item"
                onClick={() => this.handleChange(0)}
              >
                <RiFlag2Fill
                  size="22px"
                  color={this.getColorWithValue("NONE")}
                />{" "}
                <span className="priority-popover-text">None</span>
              </div>
            </PopoverBody>
          </Popover>
        </div>
      </div>
    );
  }
}
